export default __webpack_public_path__ + "static/media/BD_logo.86f78f77.jpeg";